import React from 'react';

import Footer from '/react4xp/components/Footer'

const FooterComponent = (props: any) => {
    return (
        <Footer {...props} />
    )
}

export default FooterComponent;
